import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";
import { CSSObject } from "@mui/system";

interface IAppBar {
  defaultProps: ComponentsProps["MuiAppBar"];
  styleOverrides: ComponentsOverrides<Theme>["MuiAppBar"];
}

const appBar: IAppBar = {
  defaultProps: {
    color: "transparent",
  },

  styleOverrides: {
    root: {
      boxShadow: "none",
    } as CSSObject,
  },
};

export default appBar;
